// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gG","advertCardHeader__actions":"c-a_gH","advertCardHeader__bottomLabel":"c-a_gJ"};